import React from 'react';
import { connect } from 'react-redux';
import ExpenseListItem from './ExpenseListItem';
import {getVisibleExpenses} from '../selectors/expenses';

export const ExpenseList = (props) => {

    return (
        <div>
            {
                props.expenses.length===0?
                <img src="./images/no-data-found.svg" alt="" className='no-data-found d-block mx-auto' /> :

                <table className='table'> 
                    <tbody>
                        {
                            props.expenses.map((expense, index) => {
                                return <ExpenseListItem key={index} expense={expense} />
                            })
                        }
                    </tbody>
                </table>
            }
        </div>
    );
};

const mapStateToProps=(state)=>{
    return {
        expenses: getVisibleExpenses(state.expenses, state.filters)
    }
}

export default connect(mapStateToProps)(ExpenseList);